import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.scss';

function MenuWrapper({ children, collaboratorsMenu }) {
  const className = classNames({
    [styles.collaboratorsMenu]: collaboratorsMenu,
    [styles.menu]: !collaboratorsMenu,
  });
  return (
    <div className={className}>
      {children}
    </div>
  );
}

MenuWrapper.propTypes = {
  children: PropTypes.node,
  collaboratorsMenu: PropTypes.bool,
};

MenuWrapper.defaultProps = {
  children: null,
  collaboratorsMenu: false,
};

export default MenuWrapper;



// WEBPACK FOOTER //
// ./src/app/components/NavigationBar/components/MenuWrapper/index.js